import { Button } from "@/components/ui/button";

export type ReportTab = "coaching" | "summary";

export const CallResultsReportTabs = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: ReportTab;
  setActiveTab: (tab: ReportTab) => void;
}) => {
  return (
    <div className="flex w-full flex-row justify-center space-x-4">
      <Button
        variant={activeTab === "coaching" ? "outline" : "ghost"}
        size="sm"
        onClick={() => setActiveTab("coaching")}
      >
        Coaching
      </Button>
      <Button
        variant={activeTab === "summary" ? "outline" : "ghost"}
        size="sm"
        onClick={() => setActiveTab("summary")}
      >
        Summary
      </Button>
    </div>
  );
};
